// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as V3DndBehaviour$LiteracyplanetTupperware from "./V3DndBehaviour.res.mjs";
import * as TupperwareLayoutSwitch$LiteracyplanetTupperware from "./TupperwareLayoutSwitch.res.mjs";
import * as PilotClozeDropBucketContainer$LiteracyplanetTupperware from "./PilotClozeDropBucketContainer.res.mjs";

function SkilfulClozeDropBucketContainer(props) {
  var children = props.children;
  var id = props.id;
  if (Curry._1(TupperwareLayoutSwitch$LiteracyplanetTupperware.use, undefined) === "Pilot") {
    return React.createElement(PilotClozeDropBucketContainer$LiteracyplanetTupperware.make, {
                id: id,
                limitNumberOfItems: props.limitNumberOfItems,
                hasHeader: props.hasHeader,
                children: children
              });
  } else {
    return React.createElement(V3DndBehaviour$LiteracyplanetTupperware.Drop.make, {
                id: id,
                children: children
              });
  }
}

var make = SkilfulClozeDropBucketContainer;

var $$default = SkilfulClozeDropBucketContainer;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
